import { SHA1 } from "./sha1-js";
import _ from "lodash"; // cool kids know _ is low-dash
import moment from "moment";

function encrypt(data) {
    let np = SHA1.sha1(data)
    return np;
};

function removeFromArray (array, value) {
    var i = array.indexOf(value);
    if (i > -1) {
        array.splice(i, 1);
    }

    return array;
}

function cloneObject(original){
    // copy
    var clone = _.cloneDeep(original);
    return clone;
}

// prima e ultima data lezione del corso (null se nessuna lezione ha una data)
function getCourseDates(episodes) {
    var dates = (episodes || []).filter(e => e.episodeDate).map(e => moment(e.episodeDate));
    if (dates.length === 0) {
        return { start: null, end: null };
    }
    return { start: moment.min(dates), end: moment.max(dates) };
}

// il certificato è disponibile dal giorno successivo all'ultima lezione
function getCertificateAvailableFrom(episodes) {
    var end = getCourseDates(episodes).end;
    return end ? end.clone().add(1, 'day').startOf('day') : null;
}

function isCourseEnded(episodes) {
    var availableFrom = getCertificateAvailableFrom(episodes);
    return availableFrom === null || !moment().isBefore(availableFrom);
}

export const Utils = {
    cloneObject: cloneObject,
    removeFromArray: removeFromArray,
    encrypt: encrypt,
    getCourseDates: getCourseDates,
    getCertificateAvailableFrom: getCertificateAvailableFrom,
    isCourseEnded: isCourseEnded
};